import React, { useState } from 'react'
import PplSearch from './PplSearch';
import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import Footer from '../../components/footer';
import Gotop from '../../components/gotop';
import FormSearch from '../../components/formsearch';
import PopupEm from '../../components/popup/PopupEm';
import Form2 from '../../components/formsearch/Form2';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import CRHeader from '../../components/header/CRHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import dataJobs from "../../assets/fakeData/dataJobs";
import dataCandi from "../../assets/fakeData/dataCandi";
import { Helmet } from 'react-helmet';

const PeopleSearch = () => {

  const [isShow, setShow] = useState(false);
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handlePopup = () => {
    const getPopUp = document.querySelector(".sidebar-popup");
    setShow(!isShow);
    !isShow
      ? getPopUp.classList.add("modal-menu--open")
      : getPopUp.classList.remove("modal-menu--open");
  };

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  const module = localStorage.getItem('Module')
  return (
    <>
     <Helmet>
				<title>Candidate/All | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Candidate/All | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
          module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
              <MobileHeader handleMobile={handleMobile} />}
      {module === 'Candidate' ? <LoginHeader clname="AddProfile" handleMobile={handleMobile} /> :
        module === 'Institution' ? <InstituteHeader clname="AddProfile" handleMobile={handleMobile} /> :
          module === 'Company' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
            module === 'Recruiter' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
              <NonLoginHeader clname="AddProfile" handleMobile={handleMobile} />}
      <div className="pt-70">
      <PplSearch data={dataCandi} />
     <Footer />
      <Gotop />
      </div>
    </>
  )
}

export default PeopleSearch